// JsFromRoutes CacheKey b883179724c3afb2e53cd7cd38abe526
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  reportData: /* #__PURE__ */ definePathHelper('get', '/custom_reports/:custom_report_id/report_data'),
  download: /* #__PURE__ */ definePathHelper('get', '/custom_reports/:custom_report_id/download'),
  templates: /* #__PURE__ */ definePathHelper('get', '/custom_reports/templates'),
  users: /* #__PURE__ */ definePathHelper('get', '/custom_reports/users'),
  profiles: /* #__PURE__ */ definePathHelper('get', '/custom_reports/profiles'),
  index: /* #__PURE__ */ definePathHelper('get', '/custom_reports'),
  create: /* #__PURE__ */ definePathHelper('post', '/custom_reports'),
  new: /* #__PURE__ */ definePathHelper('get', '/custom_reports/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/custom_reports/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/custom_reports/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/custom_reports/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/custom_reports/:id'),
}
